<template>
  <div
    id="main-inner"
    class="app"
    :class="{
      'full-width': disableMinWidth,
      fullscreen: isFullscreen,
      'is-vacancy': isVacancy,
      'is-adaptive': is_adaptive,
      'header-not-fixed': fixedHeader,
      'public-response': public_response,
      grid: is_grid
    }"
  >
    <!-- <site-informer v-if="!!sitemessage && showInformer"
      :message="sitemessage"
      @cancel="hideInformer"
      /> -->

    <router-view name="rates_informer" />

    <router-view name="header" :class="{ is_admin: is_admin }" />

    <div
      class="content-wrapper"
      :class="{
        'header-not-fixed': fixedHeader,
        'custom-input-fields': customInputFields,
        'min-width': !videointerviewStartOrEndPage && !disableMinWidth,
        is_admin: is_admin,
        'online-interview': online_interview
      }"
    >
      <router-view name="header_form" />

      <router-view class="content" :class="{ grid: is_grid, 'full-width': disableMinWidth }" />
    </div>

    <router-view name="footer" />
  </div>
</template>

<script>
import axios from 'axios';

import injectComponentDependency from '@/_helpers/injector.js';

import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import IEBrowserDetector from '@/components/mixin/IEBrowserDetector.js';
// const SiteInformer = () => import('@/components/SiteInformer.vue');

export default {
  name: 'OldLayout',

  // components: {
  //   // SiteInformer
  // },

  mixins: [SafariBrowserDetector, IEBrowserDetector],

  // data() {
  //   return {
  //     showInformer: true
  //   }
  // },

  computed: {
    public_response() {
      return this.$route.meta ? this.$route.meta.public_response : null;
    },

    is_grid() {
      return this.$route.name === 'vacancy_application' || this.$route.name === 'vacancy_tests';
    },

    locale() {
      return this.$store.getters['locale/current'];
    },

    processName() {
      return this.$store.getters['process/getName'];
    },

    is_admin() {
      return this.$route.meta ? this.$route.meta.is_admin : null;
    },

    headerStyle() {
      return this.$route.meta ? this.$route.meta.headerOptions : null;
    },

    online_interview() {
      return this.$route.meta ? this.$route.meta.online_interview : false;
    },

    is_adaptive() {
      return this.$route.meta ? this.$route.meta.is_adaptive : null;
    },

    fixedHeader() {
      return this.headerStyle ? this.headerStyle.fixed === false : null;
    },

    customInputFields() {
      return this.$route.meta ? this.$route.meta.customInputFields : null;
    },

    disableMinWidth() {
      return this.$route.meta ? this.$route.meta.disableMinWidth : false;
    },

    videointerviewStartOrEndPage() {
      return this.$store.getters['interview/videointerview/isStartOrEndPage'];
    },

    sitemessage() {
      return this.$store.getters['siteinformers/message'];
    },

    isNotInterviewOrRegistration() {
      return this.$route.name !== 'interview' && this.$route.name !== 'open-registration';
    },

    isFullscreen() {
      return (
        this.$route.name === 'responses' ||
        this.$route.name === 'response' ||
        this.$route.name === 'response-videointerview' ||
        this.$route.name === 'invites' ||
        this.$route.name === 'vacancies' ||
        this.$route.name === 'search' ||
        this.$route.name === 'login' ||
        this.$route.path.indexOf('/settings/') !== -1 ||
        this.$route.path.indexOf('/profile/') !== -1 ||
        this.$route.path.indexOf('/vacancies/') !== -1
      );
    },

    isVacancy() {
      return this.$route.path.indexOf('/vacancies/') !== -1;
    },

    is_public_response() {
      return this.$route.name === 'public-response';
    },

    isAdminPage() {
      return this.$route.name === 'admin';
    },

    subdomain() {
      if (!window.location || !window.location.host) {
        return '';
      }

      const host = window.location.hostname;
      const hostArray = host.split('.');
      return hostArray.slice(hostArray.length - 2).join('.');
    }
  },

  mounted() {
    if (this.$route.name !== 'registration') {
      this.set_title(this.$route);
    }
    axios.defaults.headers.common['Accept-Language'] = this.locale;

    this.$store.dispatch('siteinformers/load').then(() => {
      if (this.$route.name === 'open-registration' || this.$route.name === 'interview') {
        this.$store.commit('siteinformers/set_messages', []);
      }
    });
  },

  // beforeMount () {
  //   // this.injectDependencies()
  // },

  methods: {
    injectDependencies() {
      injectComponentDependency();
    },

    // hideInformer() {
    //   this.showInformer = false
    // },

    convert_str_to_obj(key, v) {
      let arr = key.split('.');
      let res = {};
      arr.reduce(function (result, val, i, arr) {
        if (arr[i + 1] !== undefined) {
          result[val] = {};
        } else {
          result[val] = v;
        }
        return result[val];
      }, res);
      return res;
    },

    set_title(val) {
      this.$store.commit('updatePageStatus', null);
      let title = this.$tr('pageTitles.prefix');

      if (val && val.meta && val.meta.title) {
        let routeTitle = this.$tr(val.meta.title);
        title = `${routeTitle} - ${title}`;
      }
      document.title = title;
    }
  }
};
</script>

<style lang="scss" scoped>
.noty_layout .noty_bar {
  background: none;
}
.app {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.fade-away-enter,
.fade-away-leave-to {
  opacity: 0;
}

.fade-away-enter-active,
.fade-away-leave-active {
  transition: opacity 2s ease-in-out;
}

.popupForbidden {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 9998;
  user-select: none;
}

.popupForbidden__inner {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  min-width: 500px;
  padding: 30px 50px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 10px 45px #d2d2d2;
}

.popupForbidden__content {
  font-size: 20px;
  margin-bottom: 20px;
}

.popupForbidden__button {
  width: 150px !important;
}
.site_informer {
  background-color: $green;
  min-height: 46px;
  display: flex;
  align-items: center;
}
.site_informer .si_close {
  margin-right: 15px;
  cursor: pointer;
}
.site_informer .si_info {
  color: #fff;
  font-size: 16px;
  width: 100%;
  text-align: center;
  padding: 10px 5px;
}
.app.public-response,
#main-inner.public-response {
  min-width: auto;
}
.public-response .content-wrapper {
  padding-top: 0;
}
.public-response .content-wrapper .content {
  padding: 0;
}
</style>

<style lang="scss" src="@/styles/base.scss"></style>
<style src="@/assets/styles/video.css" />
